import React, { useRef, useState } from "react";
import { estateMappingDocumentUrl } from "../api";

const formatFileSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const DocumentsField = ({ copy, documents = [], enabled, onDelete, onUpload }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const uploadFiles = (filesToUpload) => {
    const files = Array.from(filesToUpload || []);
    if (files.length === 0) return;

    setUploading(true);
    Promise.all(files.map((file) => onUpload(file)))
      .finally(() => {
        setUploading(false);
        if (inputRef.current) inputRef.current.value = "";
      });
  };

  const handleFiles = (event) => uploadFiles(event.target.files);

  const handleDragOver = (event) => {
    event.preventDefault();
    if (enabled && !uploading) setIsDragging(true);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    if (enabled && !uploading) uploadFiles(event.dataTransfer.files);
  };

  const handleDragLeave = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) setIsDragging(false);
  };

  return (
    <div className="estate-mapping__field estate-mapping__documents-field wrapper-form-item">
      <span className="input-label">{copy.form.documents}</span>
      <p className="estate-mapping__documents-description">{copy.form.documents_description}</p>
      <div
        className={`estate-mapping__documents${isDragging ? " estate-mapping__documents--dragging" : ""}`}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div className="estate-mapping__documents-header">
          <button disabled={!enabled || uploading} onClick={() => inputRef.current && inputRef.current.click()} type="button">
            {uploading ? copy.form.uploading_document : copy.form.upload_document}
          </button>
          <input multiple onChange={handleFiles} ref={inputRef} type="file" />
        </div>
        {!enabled && <div className="estate-mapping__documents-empty">{copy.form.documents_unavailable}</div>}
        {enabled && documents.length === 0 && <div className="estate-mapping__documents-empty">{copy.form.no_documents}</div>}
        {enabled && documents.length > 0 && (
          <div className="estate-mapping__documents-list">
            {documents.map((document) => (
              <div className="estate-mapping__document-row" key={document.id}>
                <a href={estateMappingDocumentUrl(document)} rel="noopener noreferrer" target="_blank">{document.file_name}</a>
                <span>{formatFileSize(document.byte_size)}</span>
                <button onClick={() => onDelete(document.id)} type="button">{copy.buttons.delete}</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsField;
